export default __webpack_public_path__ + "static/media/KZ.T.09.2216 black.65ffd880.svg";